import { useState } from 'react';
import { CollectionInfoFaq } from './clllectionInfo/faq';
import { CollectionInfoTab, CollectionInfoTabPanel } from './clllectionInfo/tab';
import { CollectionInfoDetails } from './clllectionInfo/details';

export const CollectionInfo = ({ collection }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (e, value) => setActiveTab(value);

  const tabs = [
    {
      title: 'Collection Details',
      icon: 'faq-details',
      component: <CollectionInfoDetails collection={collection} />,
    },
    {
      title: 'FAQ',
      icon: 'faq-?',
      component: <CollectionInfoFaq collection={collection} />,
    },
  ];

  return (
    <>
      <div className='flex flex-wrap items-center gap-3 md:gap-6'>
        {tabs.map((tab, index) => (
          <CollectionInfoTab
            key={index}
            active={activeTab === index}
            onClick={(e) => handleChange(e, index)}
            {...tab}
          />
        ))}
      </div>
      <div className='mt-6'>
        {tabs.map((tab, index) => (
          <CollectionInfoTabPanel key={index} value={activeTab} index={index}>
            {tab.component}
          </CollectionInfoTabPanel>
        ))}
      </div>
    </>
  );
};
